import * as S from "./styles";

import { ReactComponent as AgentIcon } from "assets/people-safe-one.svg";
import { ReactComponent as HeartIcon } from "assets/heart-like.svg";

import { IMapLocationData } from "contexts/map/types";

export type MarkerCardProps = {
  marker: IMapLocationData;
  isSelected?: boolean;
  onMapLocationChange: (coords: { lat: number; lng: number }) => void;
  onFavoriteClick: () => void;
};

export function PolicemanMarkerCard({
  marker,
  isSelected,
  onMapLocationChange,
  onFavoriteClick,
}: MarkerCardProps) {
  const { coords, name, isFavorite, working } = marker;

  const Icon = <AgentIcon />;

  function handleSeeOnMapClick() {
    onMapLocationChange(coords);
  }

  return (
    <S.PolicemanMarkerWrapper active={isSelected}>
      <S.Header>
        <S.HeaderBody>
          <S.IconContainer>{Icon}</S.IconContainer>
          <S.TextContainer>
            <h4>{name}</h4>
            <h4 onClick={handleSeeOnMapClick}>
              {coords.lat}, {coords.lng}
            </h4>
          </S.TextContainer>
        </S.HeaderBody>
        <S.HeaderFooter>
          <S.HeaderBadge work={working}>
            <span>
              {working
                ? "Trabalhando em uma ocorrência"
                : "Livre para trabalho"}
            </span>
          </S.HeaderBadge>
        </S.HeaderFooter>
      </S.Header>

      <S.OccurrenceMarkerBody>
        <S.FavoriteButton active={isFavorite} onClick={onFavoriteClick}>
          <HeartIcon />
        </S.FavoriteButton>
        <S.Button onClick={handleSeeOnMapClick}>Ver no mapa</S.Button>
      </S.OccurrenceMarkerBody>
    </S.PolicemanMarkerWrapper>
  );
}
